module.exports = __webpack_public_path__ + "static/media/100.b64efbed.webp";